module.exports = __webpack_public_path__ + "img/app_home.c268b9f2.png";